import cn from "classnames";
import Ru from "@assets/icons/flags/russia.svg?react";
import Cn from "@assets/icons/flags/china.svg?react";
import Tr from "@assets/icons/flags/turkey.svg?react";
import En from "@assets/icons/flags/usa.svg?react";
import Hk from "@assets/icons/flags/hc.svg?react";
import { FunctionComponent, SVGAttributes } from "react";
import styles from "./IconCountry.module.scss";

const icons: Record<string, FunctionComponent<SVGAttributes<SVGElement>>> = {
  EN: En,
  RU: Ru,
  TR: Tr,
  CN: Cn,
  HK: Hk,
};

export const IconCountry = ({ className, countryCode }: {
  className?: string;
  countryCode: string;
}) => {
  const Icon = icons[countryCode] ?? null;

  if (!Icon) return null
  
  return (
    <Icon className={cn(className, styles.icon)} />
  )
}
